/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M414.5 715.9c-7.7 7.7-16.4 11.6-26.1 11.6-9.7 0-18.4-3.9-26.1-11.6L200 553.6l52.2-52.2 136.2 136.2 362.3-365.2 49.3 52.2-385.5 391.3z"/>'
  }
})
